import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Authentication from "./api/Authentication/Authentication";

export const UserRoute = () => {
  const location = useLocation();
  const user = Authentication.getCurrentUser();
  // If not authenticated, redirect to login and pass the "from" location in state.
  if (user) {     
      return <Outlet />;
  } else {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
};

export const UserEnabledRoute = () => {
  const location = useLocation();
  const user = Authentication.getCurrentUser();
  
  // If not authenticated, redirect to login and pass the "from" location in state.
  if (user) {
    if (user.enabled) {      
      return <Outlet />;
    } else {
      return <Navigate to="/verification" replace />
    }
  } else {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
};

export const AdminRoute = () => {
  const user = Authentication.getCurrentUser();
  // If not authenticated, redirect to login and pass the "from" location in state.
  if (user) {
    if (user.isAdmin) {      
      return <Outlet />;
    } else {
      return <Navigate to="/" replace />
    }
  } else {
    return <Navigate to="/admin/login" replace />;
  }
};

export const AdminEnabledRoute = () => {
  const user = Authentication.getCurrentUser();
  // If not authenticated, redirect to login and pass the "from" location in state.
  if (user) {
    if (user.isAdmin && user.enabled) {      
      return <Outlet />;
    } else {
      return <Navigate to="/" replace />
    }
  } else {
    return <Navigate to="/admin/login" replace />;
  }
};

export const UserNotEnabledRoute = () => {
  const location = useLocation();
  const user = Authentication.getCurrentUser();
  // If not authenticated, redirect to login and pass the "from" location in state.
  if (user) {
    if (!user.enabled) {      
      return <Outlet />;
    } else {
      return <Navigate to="/" replace />
    }
  } else {
    return <Navigate to="/login" replace state={{ from: location }}/>;
  }
}

export const NotUserRoute = () => {
  const user = Authentication.getCurrentUser();
  // If not authenticated, redirect to login and pass the "from" location in state.
  if (user) {
    return <Navigate to="/" replace />
  } else {
    return <Outlet />;
  }
};